const JQUERY_CRON_LOCALE = {};

JQUERY_CRON_LOCALE.en = {
    ORDINALS: {
        th: 'th',
        st: 'st',
        nd: 'nd',
        rd: 'rd'
    },
    MONTH: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    DOW: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    'Every':            'Every', // start of expression
    'and':              'and', // 1, 2, 3 and 15th
    'every day':        'every day',
    'minute past the':  'minute past the',
    'hour':             'hour',
    'minute':           'minute',
    'minute of':        'minute of',
    'second':           'second',
    'second in minute': 'second in minute',
    'second of every':  'second of every',
    'minute every hour': 'minute every hour',
    'on the':           'on the',
    'of every month':   'of every month',
    'and every':        'and every',
    'At':               'At',
    'on':               'on', // on sun, mon
    'in':               'in' // in jan, apr
};

JQUERY_CRON_LOCALE.de = {
    ORDINALS: {
        th: '',
        st: '',
        nd: '',
        rd: ''
    },
    MONTH: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ],
    DOW: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ],
    'Every':            'Jede(r)', // start of expression
    'and':              'und', // 1, 2, 3 and 15th
    'every day':        'jeden Tag',
    'minute past the':  'Minuten nach',
    'hour':             'Stunde',
    'minute':           'Minute',
    'minute of':        'Minuten von',
    'second':           'Sekunde',
    'second in minute': 'Sekunde in der Minute',
    'second of every':  'Sekunde in',
    'minute every hour': 'Minute jede Stunde',
    'on the':           'am',
    'of every month':   'im jeden Monat',
    'and every':        'und am jeden',
    'At':               'Um',
    'on':               'am', // on sun, mon
    'in':               'im' // in jan, apr
};

JQUERY_CRON_LOCALE.ru = {
    ORDINALS: {
        th: '',
        st: '',
        nd: '',
        rd: ''
    },
    MONTH: [
        'Январе',
        'Феврале',
        'Марте',
        'Апреле',
        'Майе',
        'Июне',
        'Июле',
        'Августе',
        'Сентябре',
        'Октябре',
        'Ноябре',
        'Декабре'
    ],
    DOW: [
        'воскресение',
        'понедельник',
        'вторник',
        'среду',
        'четверг',
        'пятницу',
        'субботу'
    ],
    'Every':            'Каждую(ый)', // start of expression
    'and':              'и', // 1, 2, 3 and 15th
    'every day':        'каждый день',
    'minute past the':  'минуту в',
    'hour':             'часа(ов)',
    'minute':           'минуту',
    'minute of':        'минут(у) в',
    'second':           'секунду',
    'second in minute': 'секунду в минуте',
    'second of every':  'секунду каждой(го)',
    'minute every hour': 'минуту каждый час',
    'on the':           '',
    'of every month':   'числа каждого месяца',
    'and every':        'и каждый',
    'At':               'В',
    'on':               'в', // on sun, mon
    'in':               'в' // in jan, apr
};

JQUERY_CRON_LOCALE.fr = {
    ORDINALS: {
        th: 'th',
        st: 'st',
        nd: 'nd',
        rd: 'rd'
    },
    MONTH: [
        'Fév',
        'Mar',
        'Avr',
        'Mai',
        'Jun',
        'Juil',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Déc'

    ],
    DOW: [
        'Dim',
        'Lun',
        'Mar',
        'Mer',
        'Jeu',
        'Ven',
        'Sam'

    ],
    'Every':            'Chaque',
    'and':              'et',
    'every day':        'tous les jours',
    'minute past the':  'minute après le',
    'hour':             'heure',
    'minute':           'minute',
    'minute of':        'minute de',
    'second':           'seconde',
    'second in minute': 'seconde en minute',
    'second of every':  'deuxième de tous',
    'minute every hour':'minute toutes les heures',
    'on the':           'sur le',
    'of every month':   'de chaque mois',
    'and every':        'et tous',
    'At':               'À',
    'on':               'sur',
    'in':               'dans'
};

JQUERY_CRON_LOCALE.it = {
    ORDINALS: {
        th: '',
        st: '',
        nd: '',
        rd: ''
    },
    MONTH: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Pot',
        'Giu',
        'Lug',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dic'
    ],
    DOW: [
        'Dom',
        'Mon',
        'Mar',
        'Mer',
        'Gio',
        'Ve',
        'Sat'
    ],
    'Every':             'Ogni',
    'and':               'e',
    'every day':         'ogni giorno',
    'minute past the':   'minuto dopo',
    'hour':              'ora',
    'minute':            'Minuto',
    'minute of':         'minuto di',
    'second':            'secondo',
    'second in minute':  "secondo in minuto",
    'second of every':   'secondo di ogni',
    'minute every hour': 'minuto ogni ora',
    'on the':            'sul',
    'of every month':    'di ogni mese',
    'and every':         'e ogni',
    'At':                'A',
    'on':                'sopra',
    'in':                'in'
};

JQUERY_CRON_LOCALE.pt = {
    ORDINALS: {
        th: '',
        st: '',
        nd: '',
        rd: ''
    },
    MONTH: [
        'Jan',
        'Feb',
        'Mar',
        'Abr',
        'Pod',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    DOW: [
        'Dom',
        'Seg',
        'Ter',
        'Qua',
        'Qui',
        'Sex',
        'Sen'
    ],
    'Every':                'Cada',
    'and':                  'e',
    'every day':            'todo dia',
    'minute past the':      'minuto após o',
    'hour':                 'hora',
    'minute':               'minuto',
    'minute of':            'minuto de',
    'second':               'segundo',
    'second in minute':     'segundo em minuto',
    'second of every':      'segundo de cada',
    'minute every hour':    'minuto a cada hora',
    'on the':               'no',
    'of every month':       'de todos os meses',
    'and every':            'e todos',
    'At':                   'At',
    'on':                   'em',
    'in':                   'dentro'
};

JQUERY_CRON_LOCALE.pl = {
    ORDINALS: {
        th: 'th',
        st: 'st',
        nd: 'nd',
        rd: 'rd'
    },
    MONTH: [ //short or full names
        'Sty', // or 'Styczeń'
        'Lut', // or 'Luty'
        'Mar', // or 'Marzec'
        'Kwi', // or 'Kwiecień'
        'Maj', // or 'Maj'
        'Cze', // or 'Czerwiec'
        'Lip', // or 'Lipiec'
        'Sie', // or 'Sierpień'
        'Wrz', // or 'Wrzesień'
        'Paź', // or 'Październik'
        'Lis', // or 'Listopad'
        'Gru'  // or 'Grudzień'
    ],
    DOW: [ //short or full days name
        'Nie', // or 'Niedziela'
        'Pon', // or 'Poniedziałek'
        'Wto', // or 'Wtorek'
        'Śro', // or 'Środa'
        'Czw', // or 'Czwartek'
        'Pią', // or 'Piątek'
        'Sob'  // or 'Sobota
    ],
    'Every':            'Każde(go)', // start of expression
    'and':              'i', // 1, 2, 3 and 15th
    'every day':        'codziennie',
    'minute past the':  'minut po', //minute past the hour ?
    'hour':             'godzina',
    'minute':           'minut(a)',
    'minute of':        'minut po',
    'second':           'sekunda',
    'second in minute': 'sekund na minutę',
    'second of every':  'sekund co',
    'minute every hour': 'minut co godzinę',
    'on the':           'w',
    'of every month':   'każdego miesiąca',
    'and every':        'i każdego',
    'At':               'O',
    'on':               'w', // on sun, mon
    'in':               'w' // in jan, apr
};

JQUERY_CRON_LOCALE.es = {
    ORDINALS: {
        th: '',
        st: '',
        nd: '',
        rd: ''
    },
    MONTH: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'Mayo',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dic'
    ],
    DOW: [
        'Sol',
        'Lun',
        'Mar',
        'Mie',
        'Jue',
        'Vie',
        'Sab'
    ],
    'Every':                'Cada',
    'and':                  'y',
    'every day':            'cada día',
    'minute past the':      'minuto pasado el',
    'hour':                 'hora',
    'minute':               'minuto',
    'minute of':            'minuto de',
    'second':               'segundo',
    'second in minute':     'segundo en minuto',
    'second of every':      'segundo de cada',
    'minute every hour':    'minuto cada hora',
    'on the':               'sobre el',
    'of every month':       'de cada mes',
    'and every':            'y cada',
    'At':                   'A',
    'on':                   'en',
    'in':                   'en'
};

JQUERY_CRON_LOCALE.nl = {
    ORDINALS: {
        th: '',
        st: '',
        nd: '',
        rd: ''
    },
    MONTH: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dec'
    ],
    DOW: [
        'Zon',
        'Mon',
        'Di',
        'Wo',
        'Don',
        'Vrij',
        'Za'
    ],
    'Every':                'Elke',
    'and':                  'en',
    'every day':            'elke dag',
    'minute past the':      'minuut voorbij de',
    'hour':                 'uur',
    'minute':               'minuut',
    'minute of':            'minuut van',
    'second':               'tweede',
    'second in minute':     'tweede in minuut',
    'second of every':      'tweede van alles',
    'minute every hour':    'minuut elk uur',
    'on the':               'op de',
    'of every month':       'van elke maand',
    'and every':            'en elke',
    'At':                   'Op',
    'on':                   'op',
    'in':                   'in'
};

JQUERY_CRON_LOCALE['zh-cn'] = {
    ORDINALS: {
        th: '',
        st: '',
        nd: '',
        rd: ''
    },
    MONTH: [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月'
    ],
    DOW: [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
    ],
    'Every':            '每', // start of expression
    'and':              '和', // 1, 2, 3 and 15th
    'every day':        '每天',
    'minute past the':  '分钟在每天第',
    'hour':             '小时',
    'minute':           '分钟',
    'minute of':        '分钟的',
    'second':           '秒',
    'second in minute': '秒在分钟',
    'second of every':  '秒在每',
    'minute every hour': '分钟在每小时中',
    'on the':           '在',
    'of every month':   '日在每月',
    'and every':        '且每',
    'At':               '在',
    'on':               '在', // on sun, mon
    'in':               '在' // in jan, apr
};

export default JQUERY_CRON_LOCALE;
